import { Icon } from '@iconify/react';
import { useContext } from 'react';
import { ProgressContext, UserContext } from '../../../contexts';
import { useMonthlyReportStore } from '../../../store/reportStore';
import toast from 'react-hot-toast';
import { createMonthlyReport, getReportMxData } from '../../../data/mysql';
import { startOfMonth } from 'date-fns';

/**
 * 새로운 보고서를 생성한다.
 */
const ReportBaseCreator = () => {
  const { spinner } = useContext(ProgressContext);
  const { selectedMonth, setReportMxData } = useMonthlyReportStore();
  const { user } = useContext(UserContext);

  /**
   * 새로운 보고서를 생성한다.
   */
  const handleCreateReport = async () => {
    try {
      spinner.start();

      const result = await createMonthlyReport({
        userId: user.id,
        dt: Math.floor(startOfMonth(selectedMonth).getTime() / 1000),
      });

      // 보고서 생성 성공후 UI 업데이트(최신 데이터)
      result &&
        setReportMxData(
          await getReportMxData({
            userId: user.id,
            dt: Math.floor(startOfMonth(selectedMonth).getTime() / 1000),
          }),
        );
      toast.success('보고서가 생성 되었습니다.');
    } catch (e) {
      console.error(e);
      toast.error('보고서 생성에 실패하였습니다.');
    } finally {
      spinner.stop();
    }
  };

  return (
    <div className="row" style={{ marginBottom: 10 }}>
      <div className="panel panel-warning" style={{ border: '2px solid #f0ad4e', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
        <div className="panel-heading" style={{ backgroundColor: '#fcf8e3', borderBottom: '1px solid #f0ad4e' }}>
          <h3 style={{ margin: 0, color: '#8a6d3b' }}>
            <Icon icon="material-symbols:warning" style={{ marginRight: 8, color: '#f0ad4e' }} />
            <span style={{ fontWeight: 'bolder' }}>{selectedMonth.getMonth() + 1}월</span> 보고서가 생성되지 않았습니다!
          </h3>
        </div>
        <div className="panel-body p-20" style={{ padding: 20, marginTop: 20 }}>
          <button
            className="btn btn-primary btn-lg"
            onClick={handleCreateReport}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 24px',
              fontSize: '1.1em',
              fontWeight: 'bold',
            }}
          >
            <Icon
              icon="material-symbols:add-circle"
              style={{
                marginRight: 12,
                fontSize: '1.5em',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            />
            <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>{selectedMonth.getMonth() + 1}월 보고서 생성</span>
          </button>
          <div style={{ marginTop: 10, color: '#999' }}>
            # [{`${selectedMonth.getMonth() + 1}월 보고서 생성`}]을 누르면 지난 보고서의 데이터(구도자, 잃은양, 정기간행물, 교인현황 ...)가 이월됩니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportBaseCreator;
